import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popup } from "@progress/kendo-react-popup";
import { getQueuesAllProjects } from "../../shared/services/queues.service";
import { getQueueInfo } from "../../shared/services/user.service";
import QueueCard from "./Queue/QueueCard";
import { useQueueCard } from "./Queue/hooks/useQueueCard";
import { useQueueCardObject } from "./Queue/hooks/useQueueCardObject";
import "./queue.scss";

/**
 * QueueDetailsPopup component displays a single queue's details in a popup
 * Uses QueueCard component for consistent UI
 * Parent component: Header
 * @author Sejal
 */
const QueueDetailsPopup = ({ show, onClose, queueId, anchor }) => {
  const popupRef = useRef();
  const dispatch = useDispatch();
  const [queueData, setQueueData] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const queueCardHook = useQueueCardObject(queueData, setQueueData, onClose);

  /**
   * to call api on load
   */
  useEffect(() => {
    fetchQueueInfo();
  }, [queueId, show]);

  const fetchQueueInfo = async () => {
    if (queueId && show) {
      const response = await dispatch(getQueueInfo({ queueId: queueId, userId: user.id }));
      setQueueData(response);
    }
  };

  return (
    <>
      <Popup
        show={show}
        onClose={onClose}
        anchor={anchor?.current}
        anchorAlign={{ vertical: "bottom", horizontal: "left" }}
        popupAlign={{ vertical: "top", horizontal: "left" }}
        animate={true}
        popupClass='queue-details-popup-positioned'>
        <div ref={popupRef} className='queue-details-popup-content'>
          <QueueCard gridRow={queueData} index={0} queueCardHook={queueCardHook} isPopupMode={true} onClose={onClose} />
        </div>
      </Popup>
    </>
  );
};

export default QueueDetailsPopup;
